import React from 'react';
import { withFormsy } from 'formsy-react';
import PrismRadioButton from '../radioButton/prismRadioButton';
import PropTypes from 'prop-types';
import formsyUtils from './utils/formsyUtils';

class FormsyPrismRadioButton extends React.Component {
    static propTypes = {
        id: PropTypes.string,
        className: PropTypes.string,
        inputClassName: PropTypes.string,
        name: PropTypes.string,
        label: PropTypes.string,
        disabled: PropTypes.bool,
        getValue: PropTypes.func.isRequired,
        setValue: PropTypes.func.isRequired,
        onChange: PropTypes.func,
        checkboxClassName: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({ checked: PropTypes.bool })])
    };

    onChange = (value) => {
        const currentValue = this.props.getValue();
        const newValue = typeof(currentValue) === 'boolean' ? value : {...currentValue, checked: value};

        this.props.setValue(newValue);

        if (this.props.onChange) {
            this.props.onChange(newValue);
        }
    }

    render() {
        const {
            getValue,
            disabled,
            isFormDisabled
        } = this.props;

        const value = getValue();
        const checked = typeof(value) === 'boolean' ? value : value.checked;

        return (
            <PrismRadioButton
                {...formsyUtils.cleanFormsyProps(this.props)}
                disabled={disabled || isFormDisabled()}
                checked={checked}
                onChange={this.onChange}
            />
        );
    }
}

export default withFormsy(FormsyPrismRadioButton);
